import { useEffect } from 'react';

import type { NHeaderProvider } from '@app/providers/HeaderProvider/HeaderProvider.types';

import type { Dispatch, SetStateAction } from 'react';

interface UseClientFieldsEffectsProps {
  setHeader: Dispatch<SetStateAction<NHeaderProvider.Header>>;
  openCreateModal: () => void;
}

// Publishes the create-modal opener to the header context so the page header's
// "Добавить поле" button opens a clean create form (resets any prior edit
// state), mirroring how the Tags page wires its header button.
export const useClientFieldsEffects = ({
  setHeader,
  openCreateModal,
}: UseClientFieldsEffectsProps): void => {
  useEffect(() => {
    setHeader({ openClientFieldModal: openCreateModal });
  }, [setHeader, openCreateModal]);
};
